<template>
  <div style="height:100%">
    <div class="Main treeMain">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>字典管理</span>
          <el-button style="float: right;" type="primary" @click="addBtn">创建</el-button>
          <div style="float: right;" v-if="multipleSelection.length != 0">
            <span>已选中<i class="checkedNumb"> {{ multipleSelection.length }}</i>个</span>
            <el-dropdown trigger="click" @command="operationBtn">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ type: 'del', para: multipleSelection }">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div class="coreMain">
        <el-row :gutter="24">
          <el-col :span="6" style="position:relative;">
            <el-input class="treeFilter" clearable style="top:14px" placeholder="输入关键字进行过滤" v-model="filterText">
            </el-input>
            <el-tree class="filter-tree" accordion :data="treeList" :default-expanded-keys="expansion"
              :props="defaultProps" node-key="typeCode" :highlight-current="true" @node-click="changeTree"
              :filter-node-method="filterNode" style="top:70px;" ref="treeData">
            </el-tree>
          </el-col>
          <el-col :span="18" class="rightInfo">
            <div>
              <el-input class="input-with-select" placeholder="搜索字典内容" v-model="search" @keyup.enter.native="searchBtn">
                <el-button @click="searchBtn" slot="append" :disabled="search.length == 0 ? true : false"
                  icon="el-icon-search" :class="search.length == 0 ? 'ccc' : 'blue'"></el-button>
              </el-input>
              <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
            </div>
            <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%"
              @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="名称" min-width="150px" prop="typeName"></el-table-column>
              <el-table-column label="编号" min-width="150px" prop="typeCode"></el-table-column>
              <el-table-column prop="content" label="内容"></el-table-column>
              <el-table-column prop="value" label="值"></el-table-column>

              <el-table-column label="">
                <template slot-scope="scope">
                  <el-dropdown class="briefDetails" style="top:22px;right:32px" @command="command">
                    <span class="el-dropdown-link">
                      <i class="el-icon-more"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="{ type: 'edit', id: scope.row }">编辑</el-dropdown-item>
                      <el-dropdown-item :command="{ type: 'del', id: scope.row.id }">删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[10,50,100,200,500,1000]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>


    <!-- 编辑 -->
    <el-dialog title="编辑字典信息" :visible.sync="dialogFormVisible" :show-close="false" :before-close="handleClose">
      <el-form :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="字典分类" v-if="!isEdited">
          <el-select v-model="editForm.dictType" placeholder="未选择" :clearable="true" value="">
            <el-option v-for="item in addSelectList" :key="item.typeCode" :label="item.typeName" :value="item.typeCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字典名称" prop="typeName" v-if="!editForm.dictType">
          <el-input v-model="editForm.typeName" autocomplete="off" :disabled="isEdited" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="字典编号" prop="typeCode" v-if="!editForm.dictType">
          <el-input v-model="editForm.typeCode" autocomplete="off" :disabled="isEdited" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="字典内容" prop="content">
          <el-input v-model="editForm.content" autocomplete="off" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="字典值" prop="value">
          <el-input v-model="editForm.value" autocomplete="off" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addCancel">取 消</el-button>
        <el-button type="primary" @click="doSave('editForm')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import API from "../../api/api";

  export default {
    watch: {
      //过滤左侧tree的值
      filterText(val) {
        this.$refs.treeData.filter(val);
      }
    },
    data() {
      return {
        loading: false, //加载条
        total: 0,
        pageSize: 10,
        currentPage: 1,
        search: "", //搜索
        tableData: [], //列表数据
        multipleSelection: [], //选中的值
        area: "", //所属区域
        areaList: [], //所属区域下拉
        filterText: "", //过滤节点
        treeList: [], //树形数据
        expansion: [], //默认展开项
        parentId: [], //父名称数组
        nodeId: "", //节点id（包括父节点id）
        //tree树状的配置key
        defaultProps: {
          children: "children",
          label: "typeName",
          id: "typeCode"
        },
        dialogFormVisible: false, //编辑窗口
        editForm: {
          dictType: '',
          content: '',
          typeName: '',
          typeCode: '',
          value: ''
        }, //更改当前字典名称
        rules: {
          typeCode: [{
            required: true,
            pattern: /^[0-9a-zA-Z_]+$/,
            message: "请填写英文、数字或下划线",
            trigger: "blur"
          }],
          typeName: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
          content: [{
            required: true,
            message: "不能为空",
            trigger: "blur"
          }],
        },

        addSelectList: [],
        isEdited: false //是否编辑
      };
    },
    created() {},
    methods: {

      handleClose() {
        return false
      },

      filterNode(value, data) {
        if (!value) return true;
        return data.typeName.indexOf(value) !== -1;
      },
      //获取字典树形数据
      getTree() {
        this.treeDictionary(() => {
          // 异步处理节点默认项
          setTimeout(() => {
            this.$refs.treeData.setCurrentKey(this.treeList[0].typeCode); //默认选择第一个节点的父节点
            this.expansion.push(this.treeList[0].typeCode) //默认展开第一个节点
          }, 50)
          //默认查第一个父节点的列表
          this.getList(this.treeList[0].typeCode)
        })

      },


      /**
       * 查询字典code，name
       * @param callback
       */
      treeDictionary(callback = () => {}) {

        API.treeDictionary().then(res => {
          let _this = this
          if (res.code === 1) {
            _this.treeList = res.data
            if (_this.treeList.length !== 0) {
              _this.treeList.unshift({
                children: [],
                typeName: "全部字典",
                parentId: null,
                typeCode: ""
              });

              callback();
            }
          }
        })

      },


      //选择节点查询列表
      changeTree(data) {
        //data是节点的数据
        this.nodeId = data.typeCode;
        this.getList(data.typeCode);
      },
      //搜索按钮
      searchBtn() {
        this.getList(this.nodeId);
      },
      //重置
      reset() {
        this.search = "";
        this.getList(this.nodeId);
      },
      //查看字典信息
      getList(typeCode) {
        let para = {
          typeCode: typeCode,
          search: this.search,
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          content: this.search
        }
        API.listDictionary(para).then(res => {
          if (res.code === 1) {
            this.tableData = res.data.resultPage
            this.total = res.data.total
          }
        })
      },

      //批量操作-删除
      operationBtn(val) {
        if (val.type === "del") {
          let str = val.para.map(x => x.id).join(",");
          this.delBtn(str);
        }
      },

      //新增字典
      addBtn() {
        this.isEdited = false
        this.dialogFormVisible = true
        let arr = [{
          typeName: "无",
          typeCode: ""
        }]
        arr.push(...this.treeList)
        arr.splice(1, 1);
        this.addSelectList = arr
        this.$nextTick(() => {
          this.$refs['editForm'].resetFields()
        })
      },


      addCancel() {
        this.dialogFormVisible = false
      },

      doSave(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (!this.isEdited) {
              if (this.editForm.dictType) {
                this.editForm.typeCode = this.editForm.dictType
              }

              API.addDictionary(this.editForm).then(res => {
                if (res.code === 1) {
                  this.$message.success("新增成功")
                  this.treeDictionary()
                  this.reset();
                  this.addCancel()
                } else {
                  this.$message.error(res.msg)
                }
              })
            } else {
              API.updateDictionary(this.editForm).then(res => {
                if (res.code === 1) {
                  this.$message.success("更新成功")
                  this.reset();
                  this.addCancel()
                } else {
                  this.$message.error(res.msg)
                }
              })
            }
          }
        })


      },

      //列表操作
      command(val) {
        if (val.type === "del") {
          let str = val.id;
          this.delBtn(str);
        }
        if (val.type === "edit") {
          this.update(val)
        }
      },

      update(row) {
        this.isEdited = true;
        this.editForm.id = row.id.id;
        this.editForm.typeCode = row.id.typeCode;
        this.editForm.typeName = row.id.typeName;
        this.editForm.content = row.id.content;
        this.editForm.value = row.id.value;
        this.dialogFormVisible = true
      },

      //删除字典
      delBtn(id) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let para = {
            ids: id
          }
          API.delDictionary(para).then(res => {
            if (res.code === 1) {
              this.$message.success('删除成功');
              this.reset()
            } else {
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //选中的数组
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //分页
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getList(this.nodeId);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getList(this.nodeId);
      }
    },
    mounted() {
      this.getTree();
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/dict.vue